/* ------------------------- External Dependencies -------------------------- */
import React from 'react'
import {
 Box
} from 'atomic'

/* ------------------------------- Component -------------------------------- */
export default props => <Box>

</Box>


// WEBPACK FOOTER //
// ./src/interface/foundry/menu/MenuSubItem/index.js